var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoungeActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.705 1H10.5C10.2348 1 9.98043 1.10536 9.79289 1.29289C9.60536 1.48043 9.5 1.73478 9.5 2V9H2.5V0H0.5V14H2.5V11H18.5V14H20.5V5.795C20.4987 4.52369 19.9931 3.30483 19.0941 2.40588C18.1952 1.50693 16.9763 1.00132 15.705 1ZM11.5 9V3H15.705C16.4459 3.00132 17.156 3.29622 17.6799 3.8201C18.2038 4.34397 18.4987 5.05413 18.5 5.795V9H11.5Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1721_53246",
    x1: 10.5,
    y1: 0,
    x2: 10.5,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeActive);
export default __webpack_public_path__ + "static/media/lounge-active.f02888f43e9be4a507e1d08e0ffe501c.svg";
export { ForwardRef as ReactComponent };